import { SimpleGenList } from '../simpleGenList';

/**
 * Days of the week in Czech.
 * Port of C# Seznam_DnyTydne__CS.
 */
export class GenList_DaysOfWeek__CS extends SimpleGenList {
  constructor() {
    super(
      'pondělí',
      'úterý',
      'středa',
      'čtvrtek',
      'pátek',
      'sobota',
      'neděle'
    );
  }
}

/**
 * Days of the week in English.
 * Port of C# Seznam_DnyTydne__EN.
 */
export class GenList_DaysOfWeek__EN extends SimpleGenList {
  constructor() {
    super(
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday'
    );
  }
}

/**
 * Days of the week in German.
 * Port of C# Seznam_DnyTydne__DE.
 */
export class GenList_DaysOfWeek__DE extends SimpleGenList {
  constructor() {
    super(
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag',
      'Sonntag'
    );
  }
}

/**
 * Days of the week in Spanish.
 * Port of C# Seznam_DnyTydne__ES.
 */
export class GenList_DaysOfWeek__ES extends SimpleGenList {
  constructor() {
    super(
      'lunes',
      'martes',
      'miércoles',
      'jueves',
      'viernes',
      'sábado',
      'domingo'
    );
  }
}

/**
 * Days of the week in French.
 * Port of C# Seznam_DnyTydne__FR.
 */
export class GenList_DaysOfWeek__FR extends SimpleGenList {
  constructor() {
    super(
      'lundi',
      'mardi',
      'mercredi',
      'jeudi',
      'vendredi',
      'samedi',
      'dimanche'
    );
  }
}

/**
 * Days of the week in Latin.
 * Port of C# Seznam_DnyTydne__LA.
 */
export class GenList_DaysOfWeek__LA extends SimpleGenList {
  constructor() {
    super(
      'dies Lunae',
      'dies Martis',
      'dies Mercurii',
      'dies Iovis',
      'dies Veneris',
      'dies Saturni',
      'dies Solis'
    );
  }
}

/**
 * Days of the week in Russian.
 * Port of C# Seznam_DnyTydne__RU.
 */
export class GenList_DaysOfWeek__RU extends SimpleGenList {
  constructor() {
    super(
      'понедельник',
      'вторник',
      'среда',
      'четверг',
      'пятница',
      'суббота',
      'воскресенье'
    );
  }
}

/**
 * Days of the week in Slovak.
 * Port of C# Seznam_DnyTydne__SK.
 */
export class GenList_DaysOfWeek__SK extends SimpleGenList {
  constructor() {
    super(
      'pondelok',
      'utorok',
      'streda',
      'štvrtok',
      'piatok',
      'sobota',
      'nedeľa'
    );
  }
}
